<template>
  <AppLayout>
    <div class="col-12 layout-spacing">
      <div class="widget widget-six">
        <div class="widget-heading">
          <h2>Pomysły KaiZen</h2>
        </div>

        <div class="widget-content">
          <section>
            <div class="toolbar">
              <div class="section-heading">
                <h3>Moje pomysły</h3>
                <span class="total-badge">
                  {{ wnioskiLocal.length }} wniosków
                </span>
              </div>

              <button
                class="btn-primary"
                type="button"
                :disabled="saving"
                @click="startCreate"
              >
                + Nowy pomysł
              </button>
            </div>

            <div v-if="pageError" class="page-error">
              {{ pageError }}
            </div>

            <div v-if="wnioskiLocal.length" class="table-wrap">
              <table>
                <thead>
                  <tr>
                    <th>Numer</th>
                    <th>Data dodania</th>
                    <th>Temat</th>
                    <th>Obszar</th>
                    <th>Status</th>
					<th>Pliki</th>
                    <th>Akcje</th>
                  </tr>
                </thead>

                <tbody>
                  <tr v-for="record in wnioskiLocal" :key="record.id">
                    <td>{{ record.numer }}</td>
                    <td>{{ formatDate(record.created_at) }}</td>
                    <td class="text-cell">{{ record.temat }}</td>
                    <td class="text-cell">{{ record.obszar || "—" }}</td>
                    <td>
                      <span :class="['status', statusClass(record.status)]">
                        {{ statusLabel(record.status) }}
                      </span>
                    </td>
					
					<td class="files-cell">
					  <div v-if="record.files && record.files.length" class="file-list">
						<div
						  v-for="file in record.files"
						  :key="file.id"
						  class="file-item"
						>
						  <a
							class="file-link"
							:href="route('kaizen.files.download', {
							  kaizen: record.id,
							  file: file.id
							})"
						  >
							{{ file.name }}
						  </a>

							<button v-if="Number(record.status) === 0"
							  class="btn btn-sm btn-outline-danger"
							  @click="deleteFile(record, file)"
							  type="button"
							  :disabled="isDeleting(file.id)"
							  title="Usuń plik"
							>
							  <i class="bi bi-trash"></i>
							</button>
						</div>
						
					  </div>

						<span v-else class="no-files">Brak plików</span>
					 
					</td>

                    <td>
                      <div class="row-actions">
                        <button
                          v-if="Number(record.status) === 0"
                          class="action-button edit"
                          type="button"
                          :disabled="saving"
                          @click="editRecord(record)"
                        >
                          Edytuj
                        </button>
						
						 <div  v-if="Number(record.status) === 0" class="upload-controls">
						<input
						  :id="`kaizen-files-${record.id}`"
						  type="file"
						  multiple
						  class="visually-hidden"
						  :disabled="isUploading(record.id)"
						  @change="uploadFiles(record, $event)"
						/>

						<label
						  :for="`kaizen-files-${record.id}`"
						  class="action-button upload-button"
						  :class="{ 'upload-disabled': isUploading(record.id) }"
						>
						  {{ isUploading(record.id) ? "Wysyłanie..." : "+ Dodaj pliki" }}
						</label>
					  </div>
						
						
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div v-else class="empty-state">
              Brak twoich pomysłów. Dodaj swój pierwszy pomysł Kaizen.
            </div>
          </section>
        </div>
      </div>
    </div>

    <div
      v-if="modalOpen"
      class="modal-backdrop"
      @click.self="closeModal"
    >
      <section
        class="kaizen-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="kaizen-modal-title"
      >
        <header class="modal-header">
          <div>
            <div class="eyebrow">KaiZen</div>
            <h3 id="kaizen-modal-title">
              {{ editingId === null ? "Nowy pomysł" : "Edytuj pomysł" }}
            </h3>
          </div>

          <button
            class="close-button"
            type="button"
            aria-label="Zamknij"
            :disabled="saving"
            @click="closeModal"
          >
            ×
          </button>
        </header>

        <div class="modal-content">
          <form class="record-form" @submit.prevent="saveRecord">
            <div class="field">
              <label for="kaizen-temat">Temat</label>
              <textarea
                id="kaizen-temat"
                v-model="form.temat"
                rows="5"
                maxlength="10000"
                required
                :disabled="saving"
                placeholder="Opisz swój pomysł lub problem..."
              ></textarea>

              <div v-if="form.errors.temat" class="form-error">
                {{ errorMessage(form.errors.temat) }}
              </div>
            </div>

            <div class="field">
              <label for="kaizen-obszar">Obszar</label>
              <textarea
                id="kaizen-obszar"
                v-model="form.obszar"
                rows="4"
                maxlength="10000"
                :disabled="saving"
                placeholder="Wpisz obszar, którego dotyczy pomysł..."
              ></textarea>

              <div v-if="form.errors.obszar" class="form-error">
                {{ errorMessage(form.errors.obszar) }}
              </div>
            </div>

<div v-if="editingId === null" class="field">
  <label for="kaizen-new-files">Załączniki</label>

  <input
    id="kaizen-new-files"
    type="file"
    multiple
    :disabled="saving"
    @change="handleSelectedFiles"
  />

  <div v-if="selectedFiles.length" class="file-list selected-files">
    <div
      v-for="(file, index) in selectedFiles"
      :key="`${file.name}-${file.size}-${index}`"
      class="file-item"
    >
      <span>{{ file.name }}</span>

      <button
        type="button"
        class="btn btn-sm btn-outline-danger"
        :disabled="saving"
        @click="removeSelectedFile(index)"
        title="Usuń wybrany plik"
      >
        Usuń
      </button>
    </div>
  </div>

  <small>Możesz wybrać kilka plików jednocześnie.</small>
</div>

            <div v-if="formError" class="form-error">
              {{ formError }}
            </div>

            <div class="form-actions">
              <button
                class="btn-outline"
                type="button"
                :disabled="saving"
                @click="closeModal"
              >
                Anuluj
              </button>

              <button
                class="btn-primary"
                type="submit"
                :disabled="saving"
              >
                {{ saving ? "Zapisywanie..." : "Zapisz pomysł" }}
              </button>
            </div>
          </form>
        </div>
      </section>
    </div>
  </AppLayout>
</template>

<script>
import AppLayout from "@/Layouts/App.vue";
import axios from "axios";

export default {
  components: {
    AppLayout,
  },

  props: {
    wnioski: {
      type: Array,
      default: () => [],
    },

    statusy: {
      type: Object,
      default: () => ({
        0: "Nowy",
        1: "W trakcie",
        2: "Zaakceptowano",
        3: "Zrealizowano",
        4: "Odrzucony",
      }),
    },
  },

  data() {
    return {
      wnioskiLocal: this.wnioski.map(record => ({
		  ...record,
		  files: record.files || [],
		})),
      uploadingIds: [],
	  selectedFiles: [],
	  deletingFileIds: [],
      modalOpen: false,
      editingId: null,
      saving: false,
      formError: "",
      pageError: "",
      form: {
        temat: "",
        obszar: "",
        errors: {},
      },
    };
  },

  watch: {
    wnioski: {
      deep: true,
      handler(newValue) {
        this.wnioskiLocal = newValue.map(record => ({ ...record }));
      },
    },
  },

  methods: {
  handleSelectedFiles(event) {
  const files = Array.from(event.target.files || []);

  this.selectedFiles = [
    ...this.selectedFiles,
    ...files,
  ];

  // Pozwala ponownie wybrać ten sam plik.
  event.target.value = "";
},

removeSelectedFile(index) {
  this.selectedFiles.splice(index, 1);
},
isDeleting(fileId) {
  return this.deletingFileIds.includes(String(fileId));
},

async deleteFile(record, file) {
  if (this.isDeleting(file.id)) return;

  const confirmed = window.confirm(
    `Czy na pewno chcesz usunąć plik "${file.name}"?`
  );

  if (!confirmed) return;

  const fileId = String(file.id);

  this.deletingFileIds.push(fileId);
  this.pageError = "";

  try {
    await axios.delete(
      route("kaizen.files.delete", {
        kaizen: record.id,
        file: file.id,
      }),
      {
        headers: {
          Accept: "application/json",
        },
      }
    );

    const index = this.wnioskiLocal.findIndex(
      item => String(item.id) === String(record.id)
    );

    if (index !== -1) {
      this.wnioskiLocal[index].files =
        (this.wnioskiLocal[index].files || []).filter(
          item => String(item.id) !== fileId
        );
    }
  } catch (error) {
    this.pageError =
      error.response?.data?.message ||
      "Nie udało się usunąć pliku.";
  } finally {
    this.deletingFileIds = this.deletingFileIds.filter(
      id => id !== fileId
    );
  }
},

isUploading(recordId) {
  return this.uploadingIds.includes(String(recordId));
},

async uploadFiles(record, event) {
  const input = event.target;
  const selectedFiles = Array.from(input.files || []);

  if (!selectedFiles.length) return;

  const recordId = String(record.id);

  if (this.isUploading(recordId)) {
    input.value = "";
    return;
  }

  this.uploadingIds.push(recordId);
  this.pageError = "";

  const payload = new FormData();

  selectedFiles.forEach(file => {
    payload.append("attachments[]", file);
  });

  try {
    const response = await axios.post(
      route("kaizen.files.store", record.id),
      payload,
      {
        headers: {
          Accept: "application/json",
        },
      }
    );

    const updatedFiles = response.data?.files || [];

    const index = this.wnioskiLocal.findIndex(
      item => String(item.id) === recordId
    );

    if (index !== -1) {
      const existingFiles = this.wnioskiLocal[index].files || [];
      const existingIds = new Set(
        existingFiles.map(file => String(file.id))
      );

      this.wnioskiLocal[index].files = [
        ...existingFiles,
        ...updatedFiles.filter(
          file => !existingIds.has(String(file.id))
        ),
      ];
    }
  } catch (error) {
    if (error.response?.status === 422) {
      const errors = error.response.data?.errors || {};
      this.pageError =
        Object.values(errors).flat().join(" ") ||
        "Sprawdź wybrane pliki.";
    } else if (error.response?.status === 403) {
      this.pageError = "Nie masz uprawnień do dodania tych plików.";
    } else if (error.response?.status === 401) {
      this.pageError = "Sesja wygasła. Zaloguj się ponownie.";
    } else {
      this.pageError =
        error.response?.data?.message ||
        "Nie udało się przesłać plików.";
    }
  } finally {
    this.uploadingIds = this.uploadingIds.filter(
      id => id !== recordId
    );

    input.value = "";
  }
},


startCreate() {
  if (this.saving) return;

  this.editingId = null;
  this.selectedFiles = [];

  this.form = {
    temat: "",
    obszar: "",
    errors: {},
  };

  this.formError = "";
  this.pageError = "";
  this.modalOpen = true;
},

editRecord(record) {
  if (this.saving || Number(record.status) !== 0) return;

  this.editingId = record.id;
  this.selectedFiles = [];

  this.form = {
    temat: record.temat || "",
    obszar: record.obszar || "",
    errors: {},
  };

  this.formError = "";
  this.pageError = "";
  this.modalOpen = true;
},

closeModal() {
  if (this.saving) return;

  this.modalOpen = false;
  this.editingId = null;
  this.selectedFiles = [];
  this.formError = "";

  this.form = {
    temat: "",
    obszar: "",
    errors: {},
  };
},



async saveRecord() {
  if (this.saving) return;

  this.formError = "";
  this.form.errors = {};

  if (!this.form.temat.trim()) {
    this.form.errors.temat = "Temat jest wymagany.";
    return;
  }

  this.saving = true;

  const isCreating = this.editingId === null;
  const recordId = this.editingId;

  try {
    let response;

    if (isCreating) {
      // Tworzenie wniosku razem z załącznikami.
      const payload = new FormData();

      payload.append("temat", this.form.temat.trim());
      payload.append("obszar", this.form.obszar.trim());

      this.selectedFiles.forEach(file => {
        payload.append("attachments[]", file);
      });

      response = await axios.post(
        route("kaizen.store"),
        payload,
        {
          headers: {
            Accept: "application/json",
          },
        }
      );
    } else {
      // Edycja wniosku pozostaje bez zmian.
      response = await axios.put(
        route("kaizen.update", recordId),
        {
          temat: this.form.temat.trim(),
          obszar: this.form.obszar.trim() || null,
        },
        {
          headers: {
            Accept: "application/json",
          },
        }
      );
    }

    const savedRecord = response.data?.kaizen;

    if (!savedRecord || savedRecord.id == null) {
      this.formError =
        "Serwer nie zwrócił zapisanego wniosku. Sprawdź tabelę przed ponownym zapisem.";
      return;
    }

    // Aktualizuj tabelę razem z listą plików.
    const index = this.wnioskiLocal.findIndex(
      item => String(item.id) === String(savedRecord.id)
    );

    const normalizedRecord = {
      ...savedRecord,
      files: savedRecord.files ??
        (index !== -1
          ? this.wnioskiLocal[index].files || []
          : []),
    };

    if (index !== -1) {
      this.wnioskiLocal.splice(index, 1, normalizedRecord);
    } else {
      this.wnioskiLocal.unshift(normalizedRecord);
    }

    // Zamknij formularz i wyczyść dane.
    this.modalOpen = false;
    this.editingId = null;
    this.selectedFiles = [];
    this.formError = "";

    this.form = {
      temat: "",
      obszar: "",
      errors: {},
    };
  } catch (error) {
    if (error.response?.status === 422) {
      this.form.errors = error.response.data?.errors || {};
      this.formError = "Popraw błędy w formularzu.";
    } else if (error.response?.status === 401) {
      this.formError = "Sesja wygasła. Zaloguj się ponownie.";
    } else if (error.response?.status === 403) {
      this.formError = "Nie masz uprawnień do tej operacji.";
    } else if (error.response?.status === 404) {
      this.formError = "Nie znaleziono wniosku.";
    } else {
      this.formError =
        error.response?.data?.message ||
        "Nie udało się zapisać wniosku. Sprawdź, czy wniosek nie został już zapisany.";
    }
  } finally {
    this.saving = false;
  }
},


    errorMessage(error) {
      return Array.isArray(error) ? error[0] : error;
    },

    formatDate(value) {
      if (!value) return "—";

      const date = new Date(value);

      if (Number.isNaN(date.getTime())) return "—";

      return new Intl.DateTimeFormat("pl-PL", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      }).format(date);
    },

    statusLabel(status) {
      return this.statusy[Number(status)] || "Nieznany";
    },

    statusClass(status) {
      return {
        0: "status-new",
        1: "status-progress",
        2: "status-accept",
        3: "status-done",
        4: "status-rejected",
      }[Number(status)] || "";
    },
  },
};
</script>

<style scoped>
.toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 16px;
  padding: 20px 0;
}

.section-heading {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 14px;
}

.section-heading h3 {
  margin: 0;
  color: #1d2a3b;
  font-size: 21px;
  font-weight: 750;
}

.btn-outline,
.btn-primary {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 10px 15px;
  border: 1px solid #dfe6ef;
  border-radius: 9px;
  background: #fff;
  color: #40536c;
  font-size: 13px;
  font-weight: 650;
  cursor: pointer;
}

.btn-primary {
  border-color: #2864d7;
  background: #2864d7;
  color: #fff;
}

.btn-primary:hover {
  background: #1e52b9;
}

.btn-primary:disabled,
.btn-outline:disabled,
.close-button:disabled,
.action-button:disabled {
  opacity: 0.65;
  cursor: wait;
}

.total-badge {
  padding: 7px 11px;
  border-radius: 20px;
  background: #edf4ff;
  color: #2864d7;
  font-size: 12px;
  font-weight: 750;
}

.table-wrap {
  width: 100%;
  overflow-x: auto;
  margin-top: 20px;
}

table {
  width: 100%;
  border-collapse: collapse;
  text-align: left;
}

th,
td {
  padding: 13px 12px;
  border-bottom: 1px solid #edf0f5;
  font-size: 13px;
  vertical-align: top;
}

th {
  background: #f7f9fc;
  color: #64748b;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.4px;
}

td {
  color: #33445a;
}

.text-cell {
  min-width: 140px;
  max-width: 320px;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}

tbody tr:hover {
  background: #fafcff;
}

.status {
  display: inline-block;
  padding: 5px 9px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 750;
  white-space: nowrap;
}

.status-new {
  background: #dbeafe;
  color: #1d4ed8;
}

.status-progress {
  background: #fef3c7;
  color: #92400e;
}

.status-accept {
  background: #dbeafe;
  color: #1d4ed8;
}
.status-done {
  background: #d1fae5;
  color: #065f46;
}

.status-rejected {
  background: #fee2e2;
  color: #991b1b;
}

.row-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.action-button {
  padding: 7px 10px;
  border: 1px solid #dfe6ef;
  border-radius: 7px;
  background: #fff;
  font-size: 12px;
  font-weight: 650;
  cursor: pointer;
}

.action-button.edit {
  color: #2864d7;
}

.locked {
  color: #8793a5;
  font-size: 12px;
}

.empty-state {
  margin-top: 20px;
  padding: 28px 16px;
  border: 1px dashed #dfe6ef;
  border-radius: 10px;
  color: #8793a5;
  text-align: center;
  font-size: 13px;
}

.modal-backdrop {
  position: fixed;
  z-index: 99999;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  overflow-y: auto;
  background: rgba(20, 32, 48, 0.55);
}

.kaizen-modal {
  position: relative;
  width: min(100%, 650px);
  max-height: calc(100vh - 40px);
  overflow-y: auto;
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 24px 80px rgba(0, 0, 0, 0.2);
}

.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 22px 26px;
  border-bottom: 1px solid #edf0f5;
}

.modal-header h3 {
  margin: 0;
  color: #1d2a3b;
  font-size: 21px;
  font-weight: 750;
}

.eyebrow {
  margin-bottom: 8px;
  color: #6480a3;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 1.7px;
}

.close-button {
  width: 36px;
  height: 36px;
  flex-shrink: 0;
  border: 0;
  border-radius: 9px;
  background: #f2f5f9;
  color: #526176;
  font-size: 25px;
  cursor: pointer;
}

.modal-content {
  padding: 22px 26px 26px;
}

.record-form {
  display: grid;
  gap: 20px;
}

.field {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.field label {
  color: #40536c;
  font-size: 13px;
  font-weight: 700;
}

.field textarea {
  display: block;
  width: 100%;
  min-height: 100px;
  padding: 12px;
  border: 1px solid #dfe6ef;
  border-radius: 9px;
  background: #fff;
  color: #25364b;
  font: inherit;
  font-size: 14px;
  resize: vertical;
  box-sizing: border-box;
}

.field textarea:focus {
  outline: 2px solid #2864d7;
  outline-offset: 1px;
}

.field textarea:disabled {
  opacity: 0.7;
}

.form-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 10px;
  padding-top: 5px;
}

.form-error,
.page-error {
  padding: 11px 13px;
  border-radius: 8px;
  background: #fff0f0;
  color: #a33434;
  font-size: 13px;
}

@media (max-width: 768px) {
  .toolbar {
    align-items: flex-start;
    flex-direction: column;
  }

  .modal-backdrop {
    padding: 10px;
  }

  .modal-header,
  .modal-content {
    padding: 17px 14px;
  }

  th,
  td {
    padding: 10px 8px;
  }
}

.files-cell {
  min-width: 180px;
  max-width: 280px;
}

.file-list {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 7px;
  margin-bottom: 10px;
}

.file-link {
  display: inline-flex;
  align-items: flex-start;
  gap: 6px;
  color: #2864d7;
  font-size: 12px;
  text-decoration: none;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.file-link:hover {
  text-decoration: underline;
}

.no-files {
  display: block;
  margin-bottom: 10px;
  color: #8793a5;
  font-size: 12px;
}

.upload-controls {
  margin-top: 8px;
}

.upload-button {
  display: inline-flex;
  color: #2864d7;
  cursor: pointer;
}

.upload-button.upload-disabled {
  opacity: 0.6;
  pointer-events: none;
}

.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.file-item {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  margin-bottom: 8px;
}

.file-item .file-link {
  flex: 1;
  min-width: 0;
  overflow-wrap: anywhere;
}

</style>
